import { createApiSlice } from "@common";
import {
  GET_CUSTOMER_USER_ROLES,
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "getCustomerUserRoles",
    method: "get",
    url: GET_CUSTOMER_USER_ROLES,
    stateKey: "data",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "customerUserRole",
  apiConfig,
  customReducers
);
const customerUserRoleSlice = slice;
// Export the slice's reducer
export default customerUserRoleSlice.reducer;


// Destructure and export thunks directly from thunksExports
export const {
  getCustomerUserRoles,
} = thunks;

